import { useCallback } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth';
import { LIBRARY_ID } from '../gallery/config';
import { applyExifDeepLink, INITIAL_GALLERY_STATE, type ExifDeepLink } from '../gallery/state';
import { galleryLinkFor } from '../gallery/url-state';
import { ExifPublishPage } from './ExifPublishPage';

/**
 * Route de l'outil « PUBLIER DES TAGS VERS EXIF » (`/outils/exif-publier`) — issu du
 * SPLIT de l'ancien Outil EXIF (v0.53.0).
 *
 * Rend la PAGE de publication sous l'en-tête persistant (× / fil d'Ariane = retour
 * galerie). Le lien profond « compteur → galerie filtrée » NAVIGUE vers la route
 * galerie avec les bons query params (le filtre vit dans l'URL, adressable).
 *
 * Sans bibliothèque associée au compte → redirection vers l'accueil (comme l'Outil
 * EXIF : l'entrée est gated côté galerie).
 */
export function ExifPublishRoute(): React.JSX.Element {
  const navigate = useNavigate();
  const { user } = useAuth();
  const libraryId = user?.libraryId ?? LIBRARY_ID;

  const onClose = useCallback(() => navigate('/'), [navigate]);

  const onDeepLink = useCallback(
    (link: ExifDeepLink) => {
      const next = applyExifDeepLink(INITIAL_GALLERY_STATE, link);
      navigate(galleryLinkFor(next));
    },
    [navigate],
  );

  if (!libraryId) return <Navigate to="/" replace />;

  return <ExifPublishPage libraryId={libraryId} onClose={onClose} onDeepLink={onDeepLink} />;
}
